import { COLLECTION_IDS } from "../../../config/collections.js";
const formatVehicleDealership = (extItem) => {
  const { locations } = extItem.data;
  if (locations) {
    const dealershipLocation = locations.find(
      (location) => location.collection_id === COLLECTION_IDS.dealersDealership
    );
    return dealershipLocation;
  }
  return null;
};
export {
  formatVehicleDealership
};
